import InvestItem from './invest-item';

export default InvestItem;
